import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";
export const VALIDATE_UPLOADED_CHARGE_DATA = "VALIDATE_UPLOADED_CHARGE_DATA";

export const service = async (data) => {
  const options: object = {
    url: '/api/EaCaseApiController/ValidateUploadedChargeData',
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(VALIDATE_UPLOADED_CHARGE_DATA, service, mock);
